// @ts-nocheck
import { borderTypes, sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import merge from "lodash/merge";

merge(sizeVariantValues, {
    default: {
        fontSize: 16,
        height: 44,
        descriptionLineSpacing: 5,
        borderRadius: 6,
        icon: 20,
    },
    small: {
        fontSize: 14,
        height: 34,
        descriptionLineSpacing: 5,
        borderRadius: 5,
        icon: 17,
    },
    xsmall: {
        fontSize: 14,
        height: 32,
        icon: 15,
        iconPadding: 0,
        descriptionLineSpacing: 5,
        borderRadius: 3,
        leftLabelPadding: 7,
    },
});

merge(borderTypes, {
    inactive: {
        color: "colors.common.borderLight",
    },
    error: {
        width: "1",
    },
});
